import { Box, Button, NoticeBox, Text, useToggle } from '@factorialco/deprecated-design-system'
import { EmployeeBlocksEmployeeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import RegularAccessModal from 'modules/employees/components/Actions/RegularAccessModal'
import hasRegularAccess from 'modules/employees/lib/hasRegularAccess'

interface Props {
  employee: EmployeeBlocksEmployeeFragment
  canSeeFutureEmployees: boolean
}

const RegularAccessBanner = ({ employee, canSeeFutureEmployees }: Props) => {
  const { canCreateEmployees, employee: currentEmployee } = useCurrentSession()
  const [openRegularAccessModal, toggleRegularAccessModal] = useToggle(false)

  if (
    !canSeeFutureEmployees ||
    (currentEmployee && !hasRegularAccess(currentEmployee.hasRegularAccess)) ||
    employee.isTerminating ||
    hasRegularAccess(employee.hasRegularAccess)
  ) {
    return null
  }

  return (
    <>
      <NoticeBox
        color="grey000White"
        iconColor="grey600"
        border={{
          bottom: {
            style: 'solid',
            width: 's1',
            color: 'grey400',
          },
        }}
        message={
          <Box gap="s8" flexDirection="row">
            <Text.Normal weight="medium">{i18n.t('employees.regular_access_banner')}</Text.Normal>
            <HelpCenterLink name="welcome_space">{i18n.t('employees.more_info')}</HelpCenterLink>
          </Box>
        }
        alignItems="center"
        fullWidth
        component={
          canCreateEmployees && (
            <Box paddingLeft="s8">
              <Button onClick={toggleRegularAccessModal(true)}>
                {i18n.t('employees.regular_access_action')}
              </Button>
            </Box>
          )
        }
      />
      {openRegularAccessModal && (
        <RegularAccessModal employeeId={employee.id} onClose={toggleRegularAccessModal(false)} />
      )}
    </>
  )
}

export default observer(RegularAccessBanner)
